(ns common.ai.deal-one-pager-sources
  "Data-driven registry for the first AI deal one-pager context sources."
  (:require
   [common.schema.entities.ai-summary-configuration.options :as options]))

(def source-registry
  [{:root-kind :deal
    :aspect :fields
    :source options/data-source-deal-fields
    :label-key :deal-one-pager/source-deal-fields}
   {:root-kind :deal
    :aspect :attachments
    :source options/data-source-deal-attachments
    :label-key :deal-one-pager/source-deal-attachments}
   {:root-kind :deal
    :aspect :activities
    :source options/data-source-deal-activities
    :label-key :deal-one-pager/source-deal-activities}
   {:root-kind :deal
    :aspect :linked-persons
    :source options/data-source-deal-linked-persons
    :label-key :deal-one-pager/source-deal-linked-persons}
   {:root-kind :target
    :aspect :fields
    :source options/data-source-target-fields
    :label-key :deal-one-pager/source-target-fields}
   {:root-kind :target
    :aspect :attachments
    :source options/data-source-target-attachments
    :label-key :deal-one-pager/source-target-attachments}
   {:root-kind :target
    :aspect :activities
    :source options/data-source-target-activities
    :label-key :deal-one-pager/source-target-activities}
   {:root-kind :target
    :aspect :linked-persons
    :source options/data-source-target-linked-persons
    :label-key :deal-one-pager/source-target-linked-persons}
   {:root-kind :profile
    :aspect :fields
    :source options/data-source-target-investor-profile-fields
    :label-key :deal-one-pager/source-profile-fields}
   {:root-kind :profile
    :aspect :attachments
    :source options/data-source-target-investor-profile-attachments
    :label-key :deal-one-pager/source-profile-attachments}
   {:root-kind :profile
    :aspect :activities
    :source options/data-source-target-investor-profile-activities
    :label-key :deal-one-pager/source-profile-activities}
   {:root-kind :profile
    :aspect :linked-persons
    :source options/data-source-target-investor-profile-linked-persons
    :label-key :deal-one-pager/source-profile-linked-persons}])

(def all-sources
  (set (map :source source-registry)))

(def activity-sources
  (->> source-registry
       (filter (fn [entry]
                 (= :activities (:aspect entry))))
       (map :source)
       set))

(def attachment-sources
  (->> source-registry
       (filter (fn [entry]
                 (= :attachments (:aspect entry))))
       (map :source)
       set))

(defn normalize
  [selected-data-sources]
  (if (nil? selected-data-sources)
    all-sources
    (set selected-data-sources)))

(defn source
  [root-kind aspect]
  (some (fn [entry]
          (when (and (= root-kind (:root-kind entry))
                     (= aspect (:aspect entry)))
            (:source entry)))
        source-registry))

(defn selected?
  [selected-data-sources {:keys [root-kind aspect]}]
  (contains? (normalize selected-data-sources)
             (source root-kind aspect)))

(defn root-selected?
  [selected-data-sources root-kind]
  (boolean
   (some (fn [entry]
           (and (= root-kind (:root-kind entry))
                (contains? (normalize selected-data-sources)
                           (:source entry))))
         source-registry)))

(defn aspect-selected?
  [selected-data-sources aspect]
  (boolean
   (some (fn [entry]
           (and (= aspect (:aspect entry))
                (contains? (normalize selected-data-sources)
                           (:source entry))))
         source-registry)))
